import { render, staticRenderFns } from "./technology_stack.vue?vue&type=template&id=5d9a24ee&scoped=true&"
import script from "./technology_stack.vue?vue&type=script&lang=js&"
export * from "./technology_stack.vue?vue&type=script&lang=js&"
import style0 from "./technology_stack.vue?vue&type=style&index=0&id=5d9a24ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a24ee",
  null
  
)

export default component.exports